/**
 * Mirrors Wellness `Opd::Data::OPD_HEADERS_MAPPING` keys/labels.
 * Keep in sync with app/core/opd/data.rb when OPD columns change.
 */
export const OPD_HEADERS_LABELS = {
  year: 'Year',
  plan_type: 'Plan Type',
  unique_claim_id: 'Unique Claim ID',
  unique_claim_count: 'Unique Claim Count',
  data_as_on: 'Data as on',
  policy_number: 'Policy No Claim',
  corporate_name: 'Corporate Name',
  entity_name: 'Entity Name',
  policy_start_date: 'Policy Start Date',
  procedure_name: 'Procedure Name',
  policy_end_date: 'Policy End Date',
  contract_start_date: 'Contract Start Date',
  contract_end_date: 'Contract End Date',
  employee_id: 'Employee ID',
  member_id: 'Member ID',
  relationship: 'Relationship',
  age: 'Age',
  gender: 'Gender',
  claim_type: 'Claim Type',
  risk_date: 'Risk Date',
  claim_received_date: 'Claim Received Date',
  claim_settled_date: 'Claim Settled Date',
  claim_amount: 'Claim Amount',
  incurred_amount: 'Incurred Amount',
  settled_amount: 'Settled Amount',
  sum_insured: 'Sum Insured',
  sub_status: 'Sub Status',
  claim_status: 'Claim Status',
  reason_of_rejected: "Adjudicator's Comment",
  icd10_codes: 'Aliment/ ICD10 Codes',
  ailment_grouping: 'Ailment Grouping',
  illness: 'Illness (Claim Ailment as per Discharge Summary)',
  hospital: 'Hospital',
  network: 'Network/Non-Network',
  insurer_name: 'Insurer Name',
  reason_of_deficiency: 'Reason of Deficiency',
  benefit_name: 'Benefit Name',
  plan_name: 'Plan Name',
  tat: 'TAT',
  tat_bracket: 'TAT Bracket',
  tat_ageing: 'TAT Ageing',
  rejection_tag: 'Claim Rejection Tag'
}

/** Same order as Wellness `Opd::Data::OPD_DATA_MAPPING.keys` */
export const OPD_DATA_MAPPING_KEYS = Object.keys(OPD_HEADERS_LABELS)

export const OPD_HEADER_MULTISELECT_OPTIONS = OPD_DATA_MAPPING_KEYS.map((key) => ({
  value: key,
  label: OPD_HEADERS_LABELS[key]
}))

export const opdHeaderLabelByKey = Object.fromEntries(
  OPD_HEADER_MULTISELECT_OPTIONS.map((o) => [o.value, o.label])
)
